import Papa, { ParseResult } from "papaparse";
import { message } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { createEducation } from "../core/data/redux/employee/employeeAction";

export const useEducationCSVImport = (
    setTableKey: React.Dispatch<React.SetStateAction<number>>
) => {
    const dispatch = useDispatch<any>();
    const { user } = useSelector((state: any) => state.auth);

    const handleEducationCSVImport = (file: File) => {
        message.loading({ content: "Importing education...", key: "edu_import" });

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,

            complete: async function (results: ParseResult<any>) {
                const rows = results.data as any[];

                let valid = 0;
                let invalid = 0;

                for (let row of rows) {
                    const employeeId = row.EmployeeId || row.EmployeeID || row.employeeID;
                    // Build payload from CSV
                    const educationPayload = {
                        HighestEducation: row.HighestEducation,
                        StudyMajor: row.StudyMajor,
                        SchoolName: row.SchoolName,
                        GraduationYear: Number(row.GraduationYear),
                        InstituteAddress: row.InstituteAddress || "",
                        GPA_Percentage: row.GPA_Percentage || "",
                        ShortNote: row.ShortNote || "",
                        StartDate: dayjs(row.StartDate).toISOString(),
                        EndDate: dayjs(row.EndDate).toISOString(),
                        CreatedBy: row.CreatedBy || user?.id,
                        ModifiedBy: user?.id,
                    };
                   
                    // Call API directly
                    const response = await dispatch(
                        createEducation({
                            employeeId,
                            educationData: educationPayload,
                        })
                    );

                    if (createEducation.rejected.match(response)) invalid++;
                    else valid++;
                }

                setTableKey((prev) => prev + 1);

                message.success({
                    content: `Education Imported: ${valid}, Skipped: ${invalid}`,
                    key: "edu_import",
                    duration: 3,
                });
            },
        });
    };

    return { handleEducationCSVImport };
};

